'use es6';

import { Record } from 'immutable';
import { RequestStatus } from 'content-detail-ui/constants/base';
const DEFAULTS = {
  limit: null,
  quantityUsed: 0,
  status: RequestStatus.UNINITIALIZED
};
export default class UsageLimits extends Record(DEFAULTS) {}